export enum PropertyQueryType {
  GET_PROPERTY_BASIC_INFO = 'GET_PROPERTY_BASIC_INFO'
}

export interface GetPropertyBasicInfoPayload {
  property_id: string;
}
